export type CardType = 'survey' | 'survey-external' | 'surveyJs' | 'poll';

export class CarouselCard {
  cardId: number | string;
  cardType: CardType;
  image: string;
  title: string;
  description: string;
  duration: string;
  reward: string;
  continueBtnText: string;
  externalUrl?: string;
  endDate?: Date;
  activeInd?: boolean;
}
